import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import React, { useState, useEffect, useRef } from "react";
import { API_STATUS } from '../../constants';
import { loginApi } from '../../apis/login/user_login';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { remove_user_login, set_user_login } from '../../redux/VerifyLogin';
import SetLoginToken from '../../utils/setlogintoken';
import { FgtUsernameApi } from '../../apis/login/fgt_username_api';
import { FgtPasswordApi } from '../../apis/login/fgt_password_api';
import { VerifyOtpApi } from '../../apis/login/verify_otp_api';
import { PassResetApi } from '../../apis/login/pass_reset_api';

export default function RetPassword() {

    const dispatch = useDispatch();
    const authState = useSelector(state => state.checkuserlogin);
    const navigate = useNavigate();

    const [login, setLogin] = useState(API_STATUS);
    const [otpApi, setOtpApi] = useState(API_STATUS);
    const [passApi, setPassApi] = useState(API_STATUS);
    const [errMsg, setErrMsg] = useState('');
    const [otpErr, setOtpErr] = useState('');
    const [success, setSuccess] = useState(false);
    const [username, setUsername] = useState('');
    const [mobile, setMobile] = useState('');
    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [vcode, setVcode] = useState('');

    const et1 = useRef();
    const et2 = useRef();
    const et3 = useRef();
    const et4 = useRef();

    const [otp1, setOtp1] = useState('');
    const [otp2, setOtp2] = useState('');
    const [otp3, setOtp3] = useState('');
    const [otp4, setOtp4] = useState('');

    useEffect(() => {
        if (authState.isLogin) {
            navigate('/');
        }
    }, [authState]);

    useEffect(() => {
        if (!login.isError && !login.isLoader) {
            if (login.data != null) {
                const res = login.data;

                if (res['status'] === 1) {
                    setStep1(false);
                    setStep2(true);

                    setMobile(res['mobile']);
                } else {
                    setErrMsg("Username not found");
                }
            }
        } else if (login.isError) {
            setErrMsg("Network error");
        }
    }, [login]);


    const SignupSchema = Yup.object().shape({
        username: Yup.string().required('Enter username')
    });

    const PassSchema = Yup.object().shape({
        password: Yup.string().min(6, 'Minimum 6 charector required').required('Enter password')
    });

    const submitOtp = () => {
        const otp = otp1.toString() + otp2.toString() + otp3.toString() + otp4.toString();
        const body = { 'username': username, 'otp': otp }
        VerifyOtpApi(body, setOtpApi);
    }

    useEffect(() => {
        if (!otpApi.isError && !otpApi.isLoader) {
            if (otpApi.data != null) {
                const res = otpApi.data;

                if (res['status'] === 1) {
                    setStep1(false);
                    setStep2(false);
                    setStep3(true);

                    setVcode(res['vcode']);
                } else {
                    setOtpErr("Wroung OTP");
                }
            }
        } else if (otpApi.isError) {
            setOtpErr("Network error");
        }
    }, [otpApi]);

    useEffect(() => {
        if (!passApi.isError && !passApi.isLoader) {
            if (passApi.data != null) {
                const res = passApi.data;

                if (res['status'] === 1) {
                    setStep1(false);
                    setStep2(false);
                    setStep3(false);
                    setSuccess(true);
                } else {
                    setStep1(true);
                    setOtpErr("Somthing went wroung");
                }
            }
        } else if (otpApi.isError) {
            setOtpErr("Network error");
        }
    }, [passApi]);

    return <div>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />

        <div className="container px-4 text-center">
            <div className="row justify-content-center pb-100 pt-100">
                <div className="col-md-4 d-none d-md-block">
                    <img src={signImg} alt='' width={450} />
                </div>


                <div className="col-md-4">
                    {
                        step1 &&
                        <Formik
                            initialValues={{
                                username: "",
                            }}
                            validationSchema={SignupSchema}
                            onSubmit={values => {
                                let body = values;
                                setUsername(body.username);
                                setErrMsg('');
                                FgtPasswordApi(body, setLogin);
                            }}
                        >
                            {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                                <div className="card bg-white shadow py-3">
                                    <div className="card-body">
                                        <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                            <img src={logo} alt='' style={{ width: 275 }} />
                                        </div>
                                        {
                                            errMsg !== "" &&
                                            <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                                <strong>Failed !!</strong><br />
                                                {errMsg}
                                            </div>
                                        }
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                <div className="text-lg">Forgot Password ?</div>
                                                <div className="text-sm">Enter your login username.</div>

                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">

                                                <div className="contact-field">
                                                    <Field className="form-control" type="text" name="username" placeholder="Username*" />
                                                </div>
                                                {
                                                    errors.username && touched.username &&
                                                    <div className='text-danger'>{errors.username}</div>
                                                }
                                            </div>

                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                {
                                                    login.isLoader &&
                                                    <div className="spinner-border text-primary" role="status">
                                                    </div>
                                                }
                                                {
                                                    !login.isLoader &&

                                                    <button
                                                        onClick={() => {
                                                            if (!isValid) {
                                                                setFieldTouched('username');
                                                            } else {
                                                                handleSubmit();
                                                            }
                                                        }}
                                                        type="button" className="button_slide slide_right orange" style={{ width: '100%' }}>Submit</button>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </Formik>
                    }
                    {
                        step2 &&
                        <div className="card bg-white shadow py-3">
                            <div className="card-body">
                                <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                    <img src={logo} alt='' style={{ width: 275 }} />
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                        {
                                            otpErr !== "" &&
                                            <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                                <strong>Failed !!</strong><br />
                                                {otpErr}
                                            </div>
                                        }
                                        <div className="text-lg">Forgot Password ?</div>
                                        <div className="text-sm mb-2">OTP is send to {mobile} number.</div>
                                        <div className='text-lg text-blue-600'>Enter  OTP</div>
                                        <div className='flex' style={{ justifyContent: 'center' }}>
                                            <input
                                                ref={et1}
                                                onChange={(v) => {
                                                    setOtp1(v.target.value);
                                                    if (v.target.value !== "") {
                                                        et2.current.focus();
                                                    }
                                                }}
                                                className="form-control" type="text" style={{ width: 50 }} />
                                            <input
                                                ref={et2}
                                                onChange={(v) => {
                                                    setOtp2(v.target.value);
                                                    if (v.target.value !== "") {
                                                        et3.current.focus();
                                                    } else {
                                                        et1.current.focus();
                                                    }
                                                }}
                                                className="form-control" type="text" style={{ width: 50 }} />
                                            <input
                                                ref={et3}
                                                onChange={(v) => {
                                                    setOtp3(v.target.value);
                                                    if (v.target.value !== "") {
                                                        et4.current.focus();
                                                    } else {
                                                        et2.current.focus();
                                                    }
                                                }}
                                                className="form-control" type="text" style={{ width: 50 }} />
                                            <input
                                                ref={et4}
                                                onChange={(v) => {
                                                    setOtp4(v.target.value);
                                                    if (v.target.value === "") {
                                                        et3.current.focus();
                                                    }
                                                }}
                                                className="form-control" type="text" style={{ width: 50 }} />
                                        </div>
                                        {
                                            otp1 !== "" && otp2 !== "" && otp3 !== "" && otp4 !== "" &&

                                            <div className="row mt-4">
                                                <div className="col-md-12">
                                                    {
                                                        otpApi.isLoader &&
                                                        <div className="spinner-border text-primary" role="status">
                                                        </div>
                                                    }
                                                    {
                                                        !otpApi.isLoader &&

                                                        <button
                                                            onClick={() => {
                                                                submitOtp();
                                                            }}
                                                            type="button" className="button_slide slide_right orange" style={{ width: '100%' }}>Verify</button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <div className='mt-3'>
                                            <Link
                                                onClick={() => {
                                                    setOtp2(false);
                                                    setOtp1(true);
                                                    setMobile('');
                                                    FgtPasswordApi({ 'username': username }, setLogin);
                                                }}
                                            >Resed OTP</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        step3 &&
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                password: "",
                                username: username,
                                vcode: vcode
                            }}
                            validationSchema={PassSchema}
                            onSubmit={values => {
                                let body = values;
                                PassResetApi(body, setPassApi);
                            }}
                        >
                            {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                                <div className="card bg-white shadow py-3">
                                    <div className="card-body">
                                        <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                            <img src={logo} alt='' style={{ width: 275 }} />
                                        </div>
                                        {
                                            errMsg !== "" &&
                                            <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                                <strong>Failed !!</strong><br />
                                                {errMsg}
                                            </div>
                                        }
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                <div className="text-lg">Reset Password</div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">

                                                <div className="contact-field">
                                                    <Field className="form-control" type="password" name="password" placeholder="New Password*" />
                                                </div>
                                                {
                                                    errors.password && touched.password &&
                                                    <div className='text-danger'>{errors.password}</div>
                                                }
                                            </div>

                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                {
                                                    passApi.isLoader &&
                                                    <div className="spinner-border text-primary" role="status">
                                                    </div>
                                                }
                                                {
                                                    !passApi.isLoader &&

                                                    <button
                                                        onClick={() => {
                                                            if (!isValid) {
                                                                setFieldTouched('password');
                                                            } else {
                                                                handleSubmit();
                                                            }
                                                        }}
                                                        type="button" className="button_slide slide_right orange" style={{ width: '100%' }}>Submit</button>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </Formik>
                    }
                    <br />

                    <div className="card bg-white shadow py-3">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    {
                                        success &&
                                        <div className='alert text-primary' style={{ textAlign: 'left' }}>
                                            <strong>Success !!</strong><br />
                                            Login password is successfully reset. Go back to login.
                                        </div>
                                    }
                                    <p style={{ color: '#969696' }}>Back to <a style={{ color: '#0d6efd' }} href="/login">Login</a> </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
}